import { render } from "./AddCustomerModal.vue?vue&type=template&id=81ffc3ec&scoped=true"
import script from "./AddCustomerModal.vue?vue&type=script&lang=js"
export * from "./AddCustomerModal.vue?vue&type=script&lang=js"

import "./AddCustomerModal.vue?vue&type=style&index=0&id=81ffc3ec&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ffc3ec"]])

export default __exports__